import React, { useEffect, useState } from 'react'

import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { Table } from 'antd';
import moment from "moment";
import { allapiAction } from '../../Redux/common/action';
import NewHeader from '../Layout/NewHeader';
import NewSidebar from '../Layout/NewSidebar';
import { URL } from '../../Service/url';
import { Tooltip } from 'react-bootstrap';

function Bonanzadetail() {

 const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const pagev = searchParams.get("page");
    const searchData = searchParams.get("search");

    const page = pagev == null ? 1 : pagev;
    const search = searchData == null ? "" : searchData;
    const [pages, setPage] = useState(1);
    const order_list = useSelector((state) =>
        state?.allapi?.my_direct_team ? state?.allapi?.my_direct_team : {}
      );
    const listdata = order_list?.docs ? order_list?.docs : [];

    useEffect(() => {
        // if (search) {
        //   dispatch(allapiAction.getSearchOrdervendor({ page: page, key: search }));
        // } else {
          dispatch(allapiAction.getBonanzaDetails({ _id: id }));
        // }
        // dispatch(allapiAction.getInvoceDetails());
        return () => {};
      }, [location]);

    const hendlePahegi = (e) => {
        setPage(e);
    
        console.log(location);
    
        navigate("/direct-team?page=" + e + "&&search=" + search);
    
        
      };
    const columns = [
            {
      title: "S.No.",
      dataIndex: "sno",
      key: "sno",
      className: "table_first_col",
      render: (value, item, index) => (page - 1) * 10 + index + 1,
    },
 {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Achiver Id",
      dataIndex: "fullName",
      key: "fullName",
    },
    {
      title: "Achiver Name",
      dataIndex: "referId",
      key: "referId",
    },
    {
      title: "Target ",
      dataIndex: "target",
      key: "target",
    },
    {
      title: "Sale",
      dataIndex: "totalsale",
      key: "totalsale",
    },

    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "startDate",
      className: "table_action_col",
      render: (value, item, index) => {
        return <>{moment(item?.startDate).format(" DD/MM/YYYY ")}</>;
      },
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      key: "endDate",
      className: "table_action_col",
      render: (value, item, index) => {
        return <>{moment(item?.endDate).format(" DD/MM/YYYY ")}</>;
      },
    },
       {
      title: "Status",
      dataIndex: "is_status",
      key: "is_status",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
         
              <button style={{ color: "brown", border: "none" }}
                className={
                  item?.achived ? "success-button ml-3" : "delete-button ml-3"
                }
                // onClick={() =>
                //   hendleToStatus(
                //     item?._id,
                //     item?.is_status   ? "Inactive" : "Active"
                //   )
                // }
              >
                {item?.achived ? "Yes" : "No"}
              </button>
         
          </>
        );
      },
    }

];

  return (
    <div>
    <NewHeader />
    <NewSidebar />
  
    <div className="main">
      <div className="my">
        <div className="container mt-5 pt-5 mb-5 pb-5 ">
  
          <div className="tableResponsive mt-10">
            <Table
              className="table antd_table custom-table"
              dataSource={listdata}
              columns={columns}
              pagination={{
                current: parseInt(page),
                pageSize: 10,
                onChange(current, pageSize) {
                  hendlePahegi(current);
                },
                hideOnSinglePage: true,
                total: order_list?.totalDocs ? order_list?.totalDocs : 0,
              }}
            />
          </div>
  
        </div>
  
        {/* STYLE TAG */}
        <style jsx="true">{`
          .custom-table {
            background: #fff;
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 5px 25px rgba(0, 0, 0, 0.1);
            margin-top: 20px;
            min-width: 800px; /* Table ka min-width */
          }
          .custom-table .ant-table-thead > tr > th {
            background-color: #a57b2e;
            color: #000000;
            font-weight: 600;
            font-size: 16px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            padding: 16px;
          }
          .custom-table .ant-table-tbody > tr > td {
            font-size: 15px;
            padding: 14px;
            background-color: #fafafa;
            border-bottom: 1px solid #eee;
          }
          .custom-table .ant-table-tbody > tr:hover > td {
            background-color: #f0f8ff;
            transition: all 0.3s;
          }
          .custom-table .ant-pagination {
            margin-top: 20px;
            text-align: center;
          }
          .tableResponsive {
            width: 100%;
            overflow-x: auto;
          }
          @media (max-width: 768px) {
            .custom-table {
              min-width: 600px;
            }
          }
          @media (max-width: 576px) {
            .custom-table {
              min-width: 500px;
            }
          }
        `}</style>
  
      </div>
    </div>
  </div>
  
  )
}

export default Bonanzadetail